import { customElement, property } from 'lit/decorators.js';
import {html, LitElement, nothing, PropertyValues} from "lit";
import {selectOptionStyles} from "@/components/select-option/select-option.styles";

/**
 * An example element.
 *
 * @slot - This element has a slot
 */
@customElement('sbk-select-option')
export class SbkSelectOption extends LitElement {

    static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

    @property()
    description: string = '';

    @property({type: Boolean})
    multiple = false;

    @property()
    label: string = "";

    @property()
    index!: number;

    @property()
    value: string = '';

    @property({type: Boolean})
    disabled = false;

    @property({type: Boolean, reflect: true})
    selected = false;

    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('aria-selected', this.selected ? 'true' : 'false');
    }

    static get styles() {
        return [
            selectOptionStyles
        ];
    }

    render() {
        return html`
            <div @mousedown=${this._selectItem} @touchdown=${this._selectItem} id=${this.index} class="select-option${this.value ? '' : ' select-option--empty-option'} ${this.multiple ? 'select-option--multiple-select' : 'select-option--single-select'} ">
                ${this.multiple ? html`<sbk-checkbox part="checkbox" label=${this.label} ?checked=${this.selected} ?disabled=${this.disabled} @checkbox-change=${this._selectItem}></sbk-checkbox>` : nothing}
                ${!this.multiple ? html`<span>${this.label}</span>` : nothing}
                ${this.descriptionTemplate()}
            </div>
        `;
    }    

    descriptionTemplate() {
        if (!this.description) {
            return '';
        }
        return html`
            <div class="select-option__description">${this.description}</div>
        `;
    }

    updated(changedProperties: PropertyValues<this>) {
        if (changedProperties.has('selected')) {
            this.setAttribute('aria-selected', this.selected ? 'true' : 'false');
        }
    }

    _selectItem() {
        const selectItemEvent = new CustomEvent('selectItem', {
            detail: { value: this.value },
            bubbles: true,
        });
        this.dispatchEvent(selectItemEvent);
    }
}
